import { NAME_MAX_LENGTH, NAME_REQUIREMENTS_MESSAGE, isValidName } from "../lib/name";

type NameFieldProps = {
  id: string;
  value: string;
  onChange: (value: string) => void;
  placeholder: string;
  required?: boolean;
};

export function NameField({ id, value, onChange, placeholder, required = false }: NameFieldProps) {
  const hasInvalidCharacters = value.trim().length > 0 && !isValidName(value);
  const messageId = `${id}-error`;

  return (
    <div>
      <input
        id={id}
        required={required}
        minLength={1}
        maxLength={NAME_MAX_LENGTH}
        className={`field ${hasInvalidCharacters ? "border-brand-red" : ""}`}
        placeholder={placeholder}
        value={value}
        onChange={(event) => onChange(event.target.value)}
        aria-invalid={hasInvalidCharacters}
        aria-describedby={hasInvalidCharacters ? messageId : undefined}
      />
      {hasInvalidCharacters && <p id={messageId} className="text-xs text-brand-red mt-1">{NAME_REQUIREMENTS_MESSAGE}</p>}
    </div>
  );
}
